import { init } from '@sentry/react';
import { SentryError } from '@/utils';

const DSN = 'https://52a3a06c27a1f1831e7245a5aaebf1d5@o4507034136870912.ingest.us.sentry.io/4508800280756224';

init({
  dsn: DSN,
  ignoreErrors: [
    'TypeError: Load failed',
    'TypeError: Failed to fetch',
    'TypeError: NetworkError when attempting to fetch resource.',
  ],
  maxBreadcrumbs: 20,
  release: process.env.REACT_APP_VERSION,
  environment: process.env.REACT_APP_ENVIRONMENT,
  allowUrls: [
    /https:\/\/storage\.googleapis\.com\/saywhatt-chat\/prod\/latest\/config\//,
    /https:\/\/storage\.googleapis\.com\/saywhatt-chat\/prod\/latest\/saywhatt-chat\.js/,
  ],
  beforeSend(event, hint) {
    const error = hint.originalException as SentryError;
    const frames = event.exception?.values?.flatMap((v) => v.stacktrace?.frames ?? []);
    const isFromWidget = frames?.some((frame) =>
      /storage\.googleapis\.com\/saywhatt-chat\/prod\/latest/.test(frame.filename ?? '')
    );
    if (!isFromWidget || error?._isSentryExcluded) {
      return null;
    }

    return event;
  },
});
